

























import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { DxPopup, DxToolbarItem } from 'devextreme-vue/popup';
import { DxTextArea } from 'devextreme-vue/text-area';

@Component({
  components: {
    DxPopup,
    DxTextArea,
    DxToolbarItem
  }
})
export default class TextPopup extends Vue {

  @Prop({ required: true })
  text!: string;

  @Prop({ default: '' })
  title!: string;

  @Prop({ required: true })
  visible!: boolean;

  @Prop({ default: '40%' })
  width!: number | string;

  @Prop({ default: '95%' })
  height!: number | string;

  get closeButtonOptions() {
    return {
      text: 'Close',
      type: 'normal',
      stylingMode: 'contained',
      onClick: this.close
    };
  }

  onHiding() {
    this.close();
  }

  private close() {
    this.$emit('hiding');
  }

}
